import AnimeCard from '@/components/base/AnimeCard';
import { animeList, trendingIds } from '@/mocks/anime';

export default function TrendingSection() {
  const trendingAnime = trendingIds
    .map((id) => animeList.find((a) => a.id === id))
    .filter(Boolean) as typeof animeList;

  return (
    <section className="py-14 md:py-20 bg-background-100" aria-labelledby="trending-title">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 id="trending-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">大家都在看的番剧</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="hidden sm:inline text-xs text-primary-600 font-medium whitespace-nowrap">
              <i className="ri-fire-line mr-1"></i>
              实时热度
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {trendingAnime.slice(0, 8).map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      </div>
    </section>
  );
}